import { z } from "zod";

export const AVATAR_COLORS = [
  "ochre",
  "teal",
  "plum",
  "moss",
  "rust",
  "rose",
  "ivory",
] as const;
export const AVATAR_EMBLEMS = ["crown", "key", "mask", "tower", "rose", "quill"] as const;
export const AVATAR_FRAMES = ["gold", "silver", "bronze"] as const;

export const MAX_IMAGE_DATA_URL = 150 * 1024;

export const avatarSchema = z.discriminatedUnion("kind", [
  z.object({
    kind: z.literal("preset"),
    color: z.enum(AVATAR_COLORS),
    emblem: z.enum(AVATAR_EMBLEMS),
    frame: z.enum(AVATAR_FRAMES),
  }),
  z.object({
    kind: z.literal("image"),
    dataUrl: z
      .string()
      .max(MAX_IMAGE_DATA_URL, "Image is too large")
      .regex(/^data:image\/(png|jpeg|webp);base64,[A-Za-z0-9+/=]+$/, "Not an image"),
    frame: z.enum(AVATAR_FRAMES),
  }),
]);

export type Avatar = z.infer<typeof avatarSchema>;
